<div
  class="atn-report-table-cell"
  [ngStyle]="styles"
>
  <div class="atn-report-table-cell__content-wrapper">
    <span>{{ value | atnDsFormattedValue: type : options }}</span>
  </div>
</div>
